'use client';
import { createContext } from 'react';
import { PassedType } from './types';

const ThemeContext = createContext<PassedType>({
  themeId: 'banzai',
  darkMode: false,
});

export { ThemeContext };

export function ThemeProvider({
  config,
  children,
}: {
  config: PassedType;
  children: React.ReactNode;
}) {
  return <ThemeContext.Provider value={config}>{children}</ThemeContext.Provider>;
}
